"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TooltipMixin = require("../../mixins/components/TooltipMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Popover = require("../Popover/Popover");
/**
 * @extends Popover
 * @subcomponents ['TooltipPopper']
 * @since 7.0.0
 */
var Tooltip = /*#__PURE__*/(0, _styledComponents.default)(_Popover.Popover).withConfig({
  displayName: "Tooltip",
  componentId: "c11n-8-100-7__sc-11y2kok-0"
})(["", ""], _TooltipMixin.TooltipMixin);
exports.Tooltip = Tooltip;
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /**
   * @deprecated Use `renderCloseButton` prop.
   */
  closeButton: _propTypes.default.node,
  /**
   * The Dialog `renderCloseButton` prop.
   */
  renderCloseButton: _propTypes.default.node,
  /**
   * @ignore
   */
  mediaQuery: _customPropTypes.default.mediaQuery,
  /**
   * A contextual popup that displays a description for an element.
   */
  role: _propTypes.default.string,
  /**
   * The Dialog `shouldCloseOnESCKeyPress` prop.
   */
  shouldCloseOnESCKeyPress: _propTypes.default.bool,
  /**
   * The Dialog `shouldCloseOnOutsideClick` prop.
   */
  shouldCloseOnOutsideClick: _propTypes.default.bool,
  /**
   * The Dialog `shouldTakeFocus` prop.
   */
  shouldTakeFocus: _propTypes.default.bool,
  /**
   * The Dialog `shouldTrapFocus` prop.
   */
  shouldTrapFocus: _propTypes.default.bool,
  /**
   * The Dialog `shouldReturnFocus` prop.
   */
  shouldReturnFocus: _propTypes.default.bool
};
Tooltip.defaultProps = {
  closeButton: null,
  renderCloseButton: null,
  mediaQuery: {},
  modal: false,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: false,
  shouldTakeFocus: false,
  shouldTrapFocus: false,
  shouldReturnFocus: false,
  role: 'tooltip'
};

/** @component */